import React from 'react';
import { DropdownButton } from 'components/alove/DropDownButton';
import { capitalize } from '@mui/material';
import { LanguageSelectorProps } from '../types';

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  languages,
  currentLanguage,
  onLanguageChange
}) => {
  if (languages.length <= 1) {
    return null;
  }

  return (
    <DropdownButton
      value={currentLanguage}
      white
      onClick={onLanguageChange}
      options={languages.map((item) => ({
        value: item.code,
        label: capitalize(item.name)
      }))}
    />
  );
}; 